export default {"src":"/_next/static/media/flagFinishPlayground3LightBg_104.7dfe5b26.svg","height":104,"width":104,"blurWidth":0,"blurHeight":0};